import { useQuery } from "@apollo/client";
import { Alert, Spin } from "antd";

import LiveStreamPlayer from "./LiveStreamPlayer";
import { LiveStreamsDocument } from "../../graphql/graphql";

interface LiveStreamsProps {
  factoryId: string;
  assetId: string;
  playAllButtonClicked: boolean;
}

export default function LiveStreams({
  factoryId,
  assetId,
  playAllButtonClicked,
}: LiveStreamsProps) {
  const { data, loading, error } = useQuery(LiveStreamsDocument, {
    fetchPolicy: "network-only",
    variables: { factoryId: factoryId, assetId: assetId },
  });

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "200px",
        }}
      >
        <Spin />
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "200px",
        }}
      >
        <Alert
          message="Error"
          description="Failed to load live streams. Please try again later."
          type="error"
          showIcon
        />
      </div>
    );
  }

  const assetData =
    data?.factory.__typename === "QueryFactorySuccess" &&
    data.factory.data.asset.__typename === "FactoryAssetSuccess"
      ? data.factory.data.asset.data
      : undefined;

  const assetSlug = assetData?.slug;
  const liveStreamData = assetData?.liveStreams;

  if (
    !assetData ||
    !assetSlug ||
    !liveStreamData ||
    liveStreamData.length === 0
  ) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "200px",
        }}
      >
        <Alert
          message="No Live Streams"
          description="There are no live streams available at the moment."
          type="info"
          showIcon
        />
      </div>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "20px",
        width: "100%",
      }}
    >
      {[...liveStreamData]
        .sort((a, b) => a.title.localeCompare(b.title))
        .map((stream) => (
          <LiveStreamPlayer
            key={stream.urlWebRTC}
            stream={stream}
            assetSlug={assetSlug}
            playAllButtonClicked={playAllButtonClicked}
          />
        ))}
    </div>
  );
}
